export const BANNER_MAX_BYTES = 6_000_000;
export const BANNER_MIN_WIDTH = 2048;
export const BANNER_MIN_HEIGHT = 1152;
export const BANNER_ASPECT_RATIO = 16 / 9;
export const BANNER_ASPECT_RATIO_TOLERANCE = 0.01;

const IMAGE_EXTENSIONS = /\.(jpe?g|png|gif|webp)$/i;

export function isBannerImageFile(file: File): boolean {
  if (file.type.startsWith("image/")) {
    return true;
  }
  return IMAGE_EXTENSIONS.test(file.name);
}

export function getBannerFileSizeError(file: File): string | null {
  if (file.size <= BANNER_MAX_BYTES) {
    return null;
  }
  const sizeMb = (file.size / (1024 * 1024)).toFixed(1);
  return `File size must be less than 6MB (selected file is ${sizeMb}MB).`;
}

export function getBannerDimensionError(
  width: number,
  height: number
): string | null {
  if (width < BANNER_MIN_WIDTH || height < BANNER_MIN_HEIGHT) {
    return `Image must be at least ${BANNER_MIN_WIDTH} x ${BANNER_MIN_HEIGHT} pixels (selected image is ${width} x ${height}). We recommend 2560 x 1440.`;
  }
  if (Math.abs(width / height - BANNER_ASPECT_RATIO) > BANNER_ASPECT_RATIO_TOLERANCE) {
    return `Image must be 16:9 aspect ratio (selected image is ${width} x ${height}). We recommend 2560 x 1440.`;
  }
  return null;
}

export function loadImageDimensions(
  file: File
): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve({ width: img.width, height: img.height });
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Failed to load image"));
    };
    img.src = objectUrl;
  });
}
